import { memo, useMemo } from 'react';
import { Stack, Typography, TypographyProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DELIVERY_TIME_TYPE_ENUM, SHIPPING_TYPE_ENUM } from '../../constants/order.enum';
import { ShippingStandardIcon } from '../icons/ShippingStandardIcon';
import { IOrder } from '../../interfaces/IOrder';
import { IconButton } from '@dfl/mui-react-common';
import themeConfig from 'settings/branding';
import { HomeIcon } from 'modules/common/components/icons';

type Props = TypographyProps & {
  value: DELIVERY_TIME_TYPE_ENUM;
  record: Pick<IOrder, 'shipping'>,
  borderRadius?: number;
};

const OrderShippingCell = ({ value, record, borderRadius = 12 }: Props) => {
  const { t } = useTranslation('order');

  const icon = useMemo(() => {
    switch (record?.shipping?.method) {
      case SHIPPING_TYPE_ENUM.HOME_DELIVERY:
        return <ShippingStandardIcon fontSize='small' />;
      default:
        return <HomeIcon fontSize='small' />;
    }
  }, [record?.shipping?.method]);

  if (!value) return null

  return (
    <Stack
      sx={{
        flexDirection: 'row',
        gap: 1,
        maxHeight: 25,
        borderRadius,
        backgroundColor: 'background.default',
        padding: '0 8px 0 0',
        alignItems: 'center',
        fontWeight: 400,
      }}
    >
      <IconButton
        tooltip={t(`shipping.shippingType.${record?.shipping?.method}`)}
        sx={{
          background: record?.shipping?.method === SHIPPING_TYPE_ENUM.HOME_DELIVERY ? themeConfig.theme.primary.main : themeConfig.theme.info.main,
          color: 'white'
        }}
      >
        {icon}
      </IconButton>
      <Typography fontSize={13} sx={{ my: 0.5 }} noWrap>
        {t(`shipping.deliveryTimeType.${value}.title`)}
      </Typography>
    </Stack>
  );
};

export default memo(OrderShippingCell);
